import React, { useState } from 'react';
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

const PalleteOccupancy = ({ resPacket }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleViewItems = (items) => {
    setSelectedItems(items ? items.split(',') : []);
    setIsModalOpen(true);
  };

  return (
    <div>
      {resPacket?.length > 0 ? (
        <div className="customTable" id="scroll">
          <table className="customTable w-100">
            <thead className="fixed-thead">
              <tr>
                <td>SNO.</td>
                <td>RACK TITLE</td>
                <td>CELL TITLE</td>
                <td>PALLETE TITLE</td>
                <td>OCCUPANCY</td>
                <td>ITEMS</td>
              </tr>
            </thead>
            <tbody className="body-scroll-custom">
              {resPacket.map((row, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{row.rackTitle}</td>
                  <td>{row.cellTitle}</td>
                  <td>{row.palletTitle}</td>
                  <td>
                    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: row.occupied ? "red" : "green",
                        }}
                      ></span>
                      <span>{row.occupied ? "Occupied" : "Unoccupied"}</span>
                    </div>
                  </td>
                  <td>
                    <Button variant="outline-primary" onClick={() => handleViewItems(row.palletItems)}>
                      View Items
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="customTable" id="scroll">No Data Found.</div>
      )}

      <Modal
        show={isModalOpen}
        onHide={() => setIsModalOpen(false)}
        aria-labelledby="contained-modal-title-vcenter"
        runTransition={true}
        centered
      >
        <Modal.Header>
          <Modal.Title>Pallet Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {selectedItems.length > 0 ? (
              selectedItems.map((item, index) => <li key={index}>{item.trim()}</li>)
            ) : (
              <p>No items available</p>
            )}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setIsModalOpen(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PalleteOccupancy;
